class MenuCategory extends ViewBasic {
    constructor(options) {
        super(options);

    }

    init(){
        let selectedChoice = localStorage.getItem('URLselected');

        if (selectedChoice) {
            let $options = this.$('option');
            $options.each(function (index, element) {
                $(element).removeAttr('data-default');

                //Display the chosen position
                if (this.value === selectedChoice) {
                    $(element).attr('data-default', '');
                }
            });
        }

        this.$header = $('.header');
        this.$navigationHeader = $('.main-navigation');
        this.skin = new Me.skin(this.$el);
        this.$menuCategory = $('.menu-category');
        this.$select = this.$('#category');

        this.$mobileMenuInitialOffset = this.$menuCategory.offset().top;

        this.$breadcrumb = $('.breadcrumb');
        this.$sideMenu = $('.side-menu-mobile-wrapper');
        this.$asideContent = $('.aside-related-content');

        this.menuIsFixed = false;

        this.addEvents();
    }

    addEvents() {
        Me.dispatch.subscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
        Me.dispatch.subscribe('MobileMenu.changeState', (e, params) => this.changeMobileMenuState(e, params));
        this.$select.on('change', e => this.changeURL());
        $(window).scroll( e => this.scrollHandler(e));
    }

    removeEvents() {
        Me.dispatch.unsubscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
        this.$select.off('change', e => this.changeURL());
    }

    changeURL() {
        let url = this.$select.val();
        if (url) {
            window.location = url;
            localStorage.setItem('URLselected', url);
        }
    }

    scrollHandler() {
        this.$mobileMenuOffset = this.$menuCategory.offset().top;
        this.$headerHeight = this.$header.height();
        this.$headerTopCSS = parseInt(this.$header.css('top'));

        if(($(window).scrollTop() + this.$headerHeight + this.$headerTopCSS) >=  this.$mobileMenuOffset && !this.menuIsFixed){

            this.changeMenuPosition();
            this.menuIsFixed = true;
        }
        else if(this.$mobileMenuInitialOffset >= this.$mobileMenuOffset && this.menuIsFixed) {
            this.$menuCategory.removeClass('fixed');

            if ($(window).width() < SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN) {
                 this.$menuCategory.css('top', this.$header.height() - this.$navigationHeader.height());
            }

            if(this.$breadcrumb.length > 0 && this.$breadcrumb.css('display') != 'none'){
                this.$breadcrumb.css('padding-top', 0);
            }
            else{
                this.$asideContent.css('padding-top', 0);
            }
            this.menuIsFixed = false;
        }
    }

    handleBreakpoints(e, params){
        this.changeMenuPosition();
    }

    changeMenuPosition(){
        this.$mobileMenuOffset = this.$menuCategory.offset().top;

        if ($(window).width() < SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN) {

            // console.log(($(window).scrollTop() + this.$header.height() - this.$navigationHeader.height()) >=  this.$mobileMenuOffset)
            if(($(window).scrollTop() + this.$header.height() - this.$navigationHeader.height()) >=  this.$mobileMenuOffset) {
                this.$menuCategory.addClass('fixed');
                if(this.$header.hasClass('isCollapsed')){
                    this.$menuCategory.css({'top': this.$header.height() - this.$navigationHeader.height() });
                }
                else{
                    this.$menuCategory.css({'top': this.$header.height() });
                }
            }
        }

        if(this.$menuCategory.hasClass('fixed')){
            //this.$asideContent.css({ 'padding-top' : this.$menuCategory.height() + this.$sideMenu.height() });
            this.$breadcrumb.css({ 'padding-top' : this.$menuCategory.height()});
        }
    }

    changeMobileMenuState(e, params){
        this.$mobileMenuOffset = this.$menuCategory.offset().top;

        if(($(window).scrollTop() + this.$header.height() + parseInt(this.$header.css('top'))) >=  this.$mobileMenuOffset) {
            if(params.isCollapsed){
                $(this.$menuCategory).css({'top': this.$header.height() - this.$navigationHeader.height() });
            }
            else if(!params.isCollapsed){
                $(this.$menuCategory).css({'top': this.$header.height()});
            }
        }
    }
}